var map = {
	"./adult_premium_white.svg": 1427,
	"./age_white.svg": 1245,
	"./annuity_start_age_white.svg": 1277,
	"./avg_premium_white.svg": 1250,
	"./currency_white.svg": 1279,
	"./datepicker_white.svg": 1392,
	"./deductible_white.svg": 1252,
	"./first_year_premium_white.svg": 1378,
	"./gender_white.svg": 1281,
	"./geographical_coverage_white.svg": 1283,
	"./income_term_white.svg": 1285,
	"./issue_age_white.svg": 1287,
	"./multiple_claims_white.svg": 1289,
	"./objective_white.svg": 1291,
	"./occupation_white.svg": 1293,
	"./owner_type_white.svg": 1295,
	"./payment_term_white.svg": 1297,
	"./property_age_white.svg": 1429,
	"./property_gross_area_white.svg": 1431,
	"./property_type_white.svg": 1299,
	"./renewal_term_white.svg": 1301,
	"./risk_preference_white.svg": 1303,
	"./room_type_white.svg": 1305,
	"./smoker_status_white.svg": 1307,
	"./sort_white.svg": 1308,
	"./sum_assured_white.svg": 1254,
	"./target_period_white.svg": 1310,
	"./total_premium_white.svg": 1312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1943;